import React from 'react';

import Typography from 'components/typography/typography';

const Diplomas2007Instructions: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        {` We hebben een digitaal uittreksel van je, voor de kinderopvang
        relevante, diploma(‘s) nodig. Deze moet voldoen aan de eisen van de wet
        Kinderopvang.`}
        <br />
        <br />
      </Typography>
      <Typography as="p" variant="body-medium" className="text-gray600">
        Controleer eerst of je met je diploma in de kinderopvang mag werken. Dit
        kan je doen op de site van{' '}
        <b className="text-current text-purple">Kinderopvang-werkt.</b>
        <br />
        <br />
      </Typography>
      <Typography as="p" variant="body-medium" className="text-gray600">
        Vervolgens download je het digitale uittreksel (pdf) vanuit het
        diplomaregister van DUO. Let op! Een screenshot of foto van je diploma
        voldoet niet.
        <br />
        <br />
        Diploma behaald voor 2007 of buitenlands diploma?
        <br />
        <br />
        Heb jij je diploma behaald voor 2007? Of heb je een buitenlands diploma?
        Dan kan je je diploma niet downloaden bij DUO en geldt er een andere
        aanpak. Je kan dit zo direct aangeven. Je krijgt dan een specifieke
        instructie voor jouw situatie.
        <br />
        <br />
        Upload in dat geval een scan of foto van je certificaat(-caten) en geef
        aan tot wanneer deze geldig is/zijn.
        <br />
        <br />
        Let erop dat scan of foto scherp en duidelijk leesbaar is.
      </Typography>
    </div>
  );
};

export default Diplomas2007Instructions;
